import { render, staticRenderFns } from "./WaterPosition.vue?vue&type=template&id=2fa1f6d2&scoped=true&"
import script from "./WaterPosition.vue?vue&type=script&lang=js&"
export * from "./WaterPosition.vue?vue&type=script&lang=js&"
import style0 from "./WaterPosition.vue?vue&type=style&index=0&id=2fa1f6d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa1f6d2",
  null
  
)

export default component.exports